// extracted by mini-css-extract-plugin
module.exports = {"tabs":"logistic_tabs__AAVwe","tabs__title":"logistic_tabs__title__yJE72"};